"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@phishtool/ui");
const styled_1 = require("./styled");
const heading_1 = require("~components/heading");
const defaultMessage = 'Oops, something went wrong.';
const ErrorComponent = ({ message = defaultMessage }) => ((0, jsx_runtime_1.jsx)(styled_1.StyledErrorWrapper, { children: (0, jsx_runtime_1.jsx)(ui_1.Grid, { children: (0, jsx_runtime_1.jsx)(ui_1.Cell, { children: (0, jsx_runtime_1.jsx)(heading_1.Heading, { color: "white", align: "center", spacer: "x0", children: message }) }) }) }));
exports.default = ErrorComponent;
